import { paneListMesasConfig } from './dataConfig.js';
import { get } from 'svelte/store';
export class configListMesa {
    listMesasConfig
    constructor() {
      this.listMesasConfig = this.getpaneListMesasConfig();
    }
    
    getpaneListMesasConfig(){
        return get(paneListMesasConfig)
    }

    updPaneListMesassettings(settings){
        paneListMesasConfig.updateSettings(settings)

    }

    rstPaneListMesassettings(){
        paneListMesasConfig.reset();
        
    }
}